











import { Component, Vue } from 'vue-property-decorator';
import NnnHeader from '@/components/NnnHeader.vue';
import NnnFooter from '@/components/NnnFooter.vue';
import { Session } from '@/types/core';
import { DateTime } from 'luxon';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

@Component({
  components: {
    NnnHeader,
    NnnFooter,
  },
})
export default class App extends Vue {

  // to support typing for vee-validate 3.0
  $refs!: {
    provider: InstanceType<typeof ValidationProvider>;
    observer: InstanceType<typeof ValidationObserver>;
  };

  created() {
    // nothing here yet
  }

  spitRoute() {
    // nothing here yet
  }
}
